export default __webpack_public_path__ + "static/media/zapier.86d7b15c.svg";